import { FrameElement, StreamActions, StreamElement } from '@hotwired/turbo'

StreamActions.reload_frame = function (this: StreamElement) {
  const targetFrameId = this.getAttribute('target')
  const frameElement: FrameElement = document.getElementById(targetFrameId) as FrameElement

  if (!targetFrameId || !frameElement) {
    console.log(`Invalid reload_frame action. Frame id ${targetFrameId} or frame not found`)
    return
  }

  const suspenseContent = this.querySelector('template')?.innerHTML || ''

  if (suspenseContent) {
    frameElement.innerHTML = suspenseContent
  }

  frameElement.reload?.call(frameElement)
}
